import React from 'react';
import {addFunc, avgFunc, fixIt} from "../../../../../components/functions/Mathematik";

function Evopo({selectedCrops, locations}) {
    const mdata1 = localStorage.getItem('sfr-fao-mdata')
    const mdata = mdata1?JSON.parse(mdata1):[]
    const dayOfYear = (date) => {
        if(!isNaN(new Date(date))) {
            let today = new Date(date)
            return Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24)
        }
    }
    let e3 = (Math.PI/180)*locations.lat
    let x3 = 101.3 * Math.pow(((293 - 0.0065 * locations.alt) / 293),5.26)
    const y3 = x3 * 0.665 / 1000
    const head1 = () => {
        let obj = []
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,index)=>{
                obj.push(
                    <td className="outlined" key={index+'name'} colSpan={8}>{crop.name}</td>
                )
                obj.push(
                    <td className="outlined" key={index+'st'} rowSpan={3}>Sug'orishga talab</td>
                )
            })
        }
        return obj
    }
    const head2 = () => {
        let obj = []
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,index)=>{
                obj.push(
                    <td className="outlined" key={index+'2b'} colSpan={2}>Boshlang‘ich</td>
                )
                obj.push(
                    <td className="outlined" key={index+'2r'} colSpan={2}>Rivojanish</td>
                )
                obj.push(
                    <td className="outlined" key={index+'2o'} colSpan={2}>O‘rta</td>
                )
                obj.push(
                    <td className="outlined" key={index+'2ox'} colSpan={2}>Oxirgi</td>
                )
            })
        }
        return obj
    }
    const head3 = () => {
        let obj = []
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,index)=>{
                obj.push(
                    <td className="outlined" key={index+'3ok1'}>Usimlik koef-nti</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok2'}>Evapo-trans-piratsiya</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok3'}>Usimlik koef-nti</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok4'}>Evapo-trans-piratsiya</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok5'}>Usimlik koef-nti</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok6'}>Evapo-trans-piratsiya</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok7'}>Usimlik koef-nti</td>
                )
                obj.push(
                    <td className="outlined" key={index+'3ok8'}>Evapo-trans-piratsiya</td>
                )
            })
        }
        return obj
    }
    const head4 = () => {
        let obj = []
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,index)=>{
                obj.push(
                    <td className="outlined" key={index+"k"}>К<sub>у</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"et"}>Et<sub>С</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"k2"}>К<sub>у</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"et2"}>Et<sub>С</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"k3"}>К<sub>у</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"et3"}>Et<sub>С</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"k4"}>К<sub>у</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"et4"}>Et<sub>С</sub></td>
                )
                obj.push(
                    <td className="outlined" key={index+"pe"}>Pe</td>
                )
            })
        }
        return obj
    }
    const checkDate = (date) => {
        if(!isNaN(new Date(date))){
            return new Date(date).toISOString().slice(0,10)
        }
    }
    const getUnixDate = (date,adddays = 0) => {
        if(!isNaN(new Date(date))){
            return new Date(date).getTime() + adddays * 86400000
        }
    }
    const xisobot = (d,i) => {
        let obj = []
        const yeardays = new Date(d.sana).getFullYear()%4==0?366:365
        let b3 = avgFunc([d.max_xavo,d.min_xavo])
        let d3 = d.shamol_tezlik*86.4
        let f3 = dayOfYear(d.sana)
        let g3 = (0.409*Math.sin(2*Math.PI*dayOfYear(d.sana)/yeardays-1.39))
        let h3 = Math.acos(-Math.tan(e3)*Math.tan(g3))
        let i3 = 1 + 0.033 * Math.cos((2 * Math.PI * yeardays)*f3)
        let j3 = ((24 * 60 / Math.PI * 0.082 * i3 * (h3 * Math.sin(e3) * Math.sin(g3) + Math.cos(e3) * Math.cos(g3) * Math.sin(h3))))
        let k3 = (24 / Math.PI) * h3
        let l3 = j3 * (0.25 + 0.5 * d.kun_soat / k3)
        let m3 = (0.75 + ((2 * Math.pow(10,-5)) * locations.alt)) * j3
        let n3 = 0.77 * l3
        let o3 = 0.6108 * Math.exp((17.27 * d.max_xavo)/(d.max_xavo + 237.3))
        let p3 = 0.6108 * Math.exp((17.27 * d.min_xavo)/(d.min_xavo + 237.3))
        let q3 = avgFunc([o3,p3])
        let r3 = 0.5 * (o3 * d.min_nam + p3 * d.max_nam) / 100
        let s3 = 4.903 * Math.pow(10,-9) * Math.pow((d.max_xavo + 273.16),4)
        let t3 = 4.903 * Math.pow(10,-9) * Math.pow((d.min_xavo + 273.16),4)
        let u3 = ((s3 + t3) / 2) * (0.34 - 0.14 * Math.pow(r3,0.5)) * (1.35 * (l3 / m3) - 0.35)
        let v3 = n3 - u3
        let w3 = 0
        let z3 = 4098 * 0.6108 * Math.exp(17.27 * b3 / (b3 + 237.3)) / Math.pow((b3 + 237.3),2)


        let a5 = checkDate(d.sana)
        let b5 = (0.408 * z3 * (v3 - w3) + y3 * (900 / (b3 + 273)) * d3 * (q3 - r3)) / (z3 + y3 * (1 + 0.34 * d3))
        let c5 = d.yogin_mm > 5 ? d.yogin_mm - 5 : 0
        obj.push(
            <td key={i+"a"} className="text-nowrap">{a5}</td>
        )
        obj.push(
            <td key={i+"b"}>{fixIt(b5)}</td>
        )
        obj.push(
            <td key={i+"c"}>{fixIt(c5)}</td>
        )
        if(Object.keys(selectedCrops).length){
            Object.values(selectedCrops).map((crop,cid)=>{
                let d5 = 0
                const cd = d.sana
                const bd = getUnixDate(crop.bosh_date)
                const rd = addFunc(bd,(parseInt(crop.bosh_d) * 86400000))
                if(cd >= bd && rd > cd){
                    d5 = crop.bosh_k
                }
                obj.push(
                    <td key={i+"d5"+cid}>{d5?fixIt(d5):''}</td>
                )
                let e5 = b5 * d5
                obj.push(
                    <td key={i+"e5"+cid}>{e5?fixIt(e5):''}</td>
                )

                let f5 = 0
                const od = addFunc(rd,(parseInt(crop.riv_d) * 86400000))
                if(cd >= rd && od > cd){
                    f5 = crop.riv_k
                }
                obj.push(
                    <td key={i+"f5"+cid}>{f5?fixIt(f5):''}</td>
                )
                let g5 = b5 * f5
                obj.push(
                    <td key={i+"g5"+cid}>{g5?fixIt(g5):''}</td>
                )

                let h5 = 0
                const oxd = addFunc(od,(parseInt(crop.orta_d) * 86400000))
                if(cd >= od && oxd > cd){
                    h5 = crop.orta_k
                }
                obj.push(
                    <td key={i+"h5"+cid}>{h5?fixIt(h5):''}</td>
                )
                let i5 = b5 * h5
                obj.push(
                    <td key={i+"i5"+cid}>{i5?fixIt(i5):''}</td>
                )

                let j5 = 0
                const jd = addFunc(oxd,(parseInt(crop.oxir_d) * 86400000))
                if(cd >= oxd && jd > cd){
                    j5 = crop.oxir_k
                }
                obj.push(
                    <td key={i+"j5"+cid}>{j5?fixIt(j5):''}</td>
                )
                let k5 = b5 * j5
                obj.push(
                    <td key={i+"k5"+cid}>{k5?fixIt(k5):''}</td>
                )
                let l5 = 0
                if((e5 + g5 + i5 + k5) != 0){
                    l5 = e5 + g5 + i5 + k5 - c5
                }
                obj.push(
                    <td key={i+"l5"+cid}>{l5?fixIt(l5):''}</td>
                )
            })
        }

        return obj
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="flextable mt-3" style={{height:"85vh"}}>
                    <table className="table table-bordered tableFixHead fao-table meteoxisob">
                        <thead style={{background:"#fff"}}>
                        <tr>
                            <td rowSpan="4" className="outlined">Sana</td>
                            <td rowSpan="3" className="outlined">Etalon evopotrans-piratsiya, mm/sutka</td>
                            <td rowSpan="3" className="outlined">Samarali yog‘in, mm</td>
                            {
                                head1()
                            }
                        </tr>
                        <tr>
                            {
                                head2()
                            }
                        </tr>
                        <tr>
                            {
                                head3()
                            }

                        </tr>
                        <tr>
                            <td className="outlined">Et<sub>0</sub></td>
                            <td className="outlined">Pe</td>
                            {
                                head4()
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            mdata.length?
                                mdata.map((d,i)=>{
                                    if(i > 1){
                                        return (
                                            <tr key={i}>
                                                {
                                                    xisobot(d,i)
                                                }
                                            </tr>
                                        )
                                    }
                                })
                                :null
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Evopo;